// Product Pickup Modules page - Pickup hotspot configuration
// Uses HotspotManager from /js/pages/hotspot-manager.js

const pickupPartsFront = [
    {
        name: "Solderless Screw<br>Mounting",
        description: "Mount any pickup securely into the module using screw terminals. No soldering required, just attach and tighten.",
        x: 20, y: -12.4,
        labelOffsetX: 6, labelOffsetY: -4,
        mobileX: 7, mobileY: 30,
        mobileLabelOffsetX: 5, mobileLabelOffsetY: -9,
        usePercentage: true
    },
    {
        name: "Pickup Height<br>Adjustment",
        description: "Easily fine-tune your tone and volume balance by precisely adjusting pickup height within the module.",
        x: 89, y: 87,
        labelOffsetX: 5, labelOffsetY: 2,
        mobileX: 98, mobileY: 53,
        mobileLabelOffsetX: -9, mobileLabelOffsetY: 10,
        usePercentage: true
    }
];

const pickupPartsBack = [
    {
        name: "Single Button<br>Eject",
        description: "Change pickups instantly with the push of a button. Quickly swap modules without any tools or wiring.",
        x: 37.8, y: 38,
        labelOffsetX: 6, labelOffsetY: -12,
        mobileX: 38.3, mobileY: 53,
        mobileLabelOffsetX: 0, mobileLabelOffsetY: 9,
        usePercentage: true
    }
];

let frontPickupHotspotManager = null;
let backPickupHotspotManager = null;
let imagesLoaded = 0;
const totalImages = 2;

function imageLoaded() {
    imagesLoaded++;
    if (imagesLoaded >= totalImages) {
        createPickupContainers();
    }
}

function createPickupContainers() {
    const preloadImgFront = document.getElementById('preload-image');
    const frontImgWidth = preloadImgFront.naturalWidth;
    const frontImgHeight = preloadImgFront.naturalHeight;

    const imageContainer = document.getElementById('image-container');
    imageContainer.innerHTML = `
        <div class="pickup-view-container" id="front-view-container" data-title="Front View">
            <div class="pickup-container" id="front-pickup-container">
                <img src="${preloadImgFront.src}" alt="Pickup Module Front View" class="pickup-image" id="pickup-image-front" width="${frontImgWidth}" height="${frontImgHeight}">
            </div>
        </div>
        <div class="pickup-view-container" id="back-view-container" data-title="Back View">
            <div class="pickup-container" id="back-pickup-container">
                <img src="https://cdn.sharkguitars.com/assets/images/pickup-back.webp" alt="Pickup Module Back View" class="pickup-image" id="pickup-image-back" width="${frontImgWidth}" height="${frontImgHeight}">
            </div>
        </div>
        <div class="mobile-overlay"></div>
        <div class="mobile-hotspot-info">
            <div class="mobile-hotspot-close">×</div>
            <h3 class="mobile-hotspot-title"></h3>
            <p class="mobile-hotspot-description"></p>
        </div>
    `;

    setTimeout(() => {
        frontPickupHotspotManager = new HotspotManager({
            containerId: 'front-pickup-container',
            parts: pickupPartsFront,
            hasLearnMore: false,
            hasOverlay: true,
            useEmUnits: true
        });

        backPickupHotspotManager = new HotspotManager({
            containerId: 'back-pickup-container',
            parts: pickupPartsBack,
            hasLearnMore: false,
            hasOverlay: true,
            useEmUnits: true
        });

        frontPickupHotspotManager.createHotspots('front-pickup-container', pickupPartsFront);
        backPickupHotspotManager.createHotspots('back-pickup-container', pickupPartsBack);
        frontPickupHotspotManager.setupMobileInteractions();
    }, 100);
}

let resizeTimer;

window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (frontPickupHotspotManager && backPickupHotspotManager) {
            frontPickupHotspotManager.handleResize();
            backPickupHotspotManager.handleResize();
            frontPickupHotspotManager.createHotspots('front-pickup-container', pickupPartsFront);
            backPickupHotspotManager.createHotspots('back-pickup-container', pickupPartsBack);
            frontPickupHotspotManager.setupMobileInteractions();
        }
    }, 250);
});

document.addEventListener('DOMContentLoaded', function () {
    imagesLoaded = 0;

    const preloadImgFront = document.getElementById('preload-image');
    if (preloadImgFront) {
        if (preloadImgFront.complete) {
            imageLoaded();
        } else {
            preloadImgFront.onload = imageLoaded;
        }
    }

    const preloadImgBack = new Image();
    preloadImgBack.src = 'https://cdn.sharkguitars.com/assets/images/pickup-back.webp';
    if (preloadImgBack.complete) {
        imageLoaded();
    } else {
        preloadImgBack.onload = imageLoaded;
    }
});
